import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20colorful%20digital%20art%20vibrant%20pink%20green%20emerald%20rose%20gradient%20glass%20crystal%20bubbles%20technology%20particles%20flowing%20light%20streams%20modern%20IT%20background%20bokeh%20neon%20glow%20artistic%20composition%20ultra%20high%20quality%20fresh%20peach%20tones%20transparent%20glossy%20surfaces&width=1920&height=800&seq=cta001&orientation=landscape"
          alt="CTA background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-pink-600/70 via-rose-500/60 to-emerald-600/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 md:px-10">
        <h2
          className="text-4xl md:text-6xl font-black text-white mb-6 tracking-wide"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          まずは無料相談から
        </h2>
        <p className="text-white/80 text-base md:text-lg mb-10 leading-relaxed">
          お客様のビジネス課題をお聞かせください<br />
          最適なソリューションをご提案いたします
        </p>
        <Link
          to="/contact"
          className="whitespace-nowrap cursor-pointer inline-flex items-center gap-3 bg-white text-gray-800 font-semibold px-8 py-4 rounded-full hover:bg-gray-50 transition-all duration-200 text-sm md:text-base"
        >
          <div className="w-7 h-7 flex items-center justify-center bg-pink-400 rounded-full">
            <i className="ri-mail-line text-white text-sm"></i>
          </div>
          お問い合わせフォームへ
          <i className="ri-arrow-right-up-line text-pink-400"></i>
        </Link>
      </div>
    </section>
  );
}
